export enum ModalType {
    SeamlessRegistration = 'seamless:after_registration',
    SeamlessCollaboration = 'seamless:by_collaboration_need',
    HeadlessSeamlessMigration = 'seamless:headless_migration',
    SeamlessPayment = 'seamless:by_payment_need',
    SeamlessHourly = 'seamless:by_hourly_need',
    SeamlessLoyalty = 'seamless:by_loyalty_need',
    SeamlessMoneyBack = 'seamless:by_money_back_need',
    SeamlessCustomOfferMoneyBack = 'seamless:custom_offer_by_money_back',
    SeamlessCustomOfferRewardsProgram = 'seamless:custom_offer_by_rewards_program',
    SeamlessUpgradeToPro = 'seamless:upgrade_to_pro',
}
